var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tips"},[_vm._v("\n    报告结果请截图保存，以便后续查看\n")])}
var staticRenderFns = []

export { render, staticRenderFns }